import { createReducer } from '@reduxjs/toolkit'

import { IntegrationReducerType } from 'types/GlobalIntegration'

import * as actions from '../../actions/Integrations/actions'
import * as authenticationActions from '../../actions/Authentication/actions'

// Initial state
const INITIAL_STATE: IntegrationReducerType = {
  data: [],
  fortnoxStatus: [],
  fetched: false,
  statusFetched: false
}

// Reducer
const integrationReducer = createReducer(INITIAL_STATE, (builder) => {
  builder
    .addCase(actions.getIntegrationsSuccess, (state, action) => {
      state.data = action.payload
      state.fetched = true
    })
    .addCase(actions.getFortnoxTenantStatusSuccess, (state, action) => {
      state.fortnoxStatus = action.payload
      state.statusFetched = true
    })
    .addCase(actions.removeFortnoxTenantSuccess, (state, action) => {
      const { activeSourceId, tenantId } = action.payload

      state.fortnoxStatus = state.fortnoxStatus.filter(
        (tenant) =>
          !(
            tenant.activeSourceId === activeSourceId &&
            tenant.tenantId === tenantId
          )
      )
    })
    .addCase(authenticationActions.signOut, () => INITIAL_STATE)
})

export default integrationReducer
